import { combineReducers } from '@reduxjs/toolkit';
import app from './slices/app.js';
import deviceSlice from './slices/device';
import user from './slices/user/user-reducer.js';
import { viewReducer } from './slices/view';
import { videoReducer } from './slices/video';
import emoji from './slices/emoji';
import { assetsSlice } from './slices/assets';
// import { mnsReducer } from './slices/mns';
import { reducer as extensionsReducer } from './slices/extensions';
import interpolationReducer from './slices/interpolation';

/**
 * @typedef {Object} State
 * @property {AppState} app
 * @property {VideoSlice} video
 * @property {EmojiState} emoji
 * @property {Widget[]} elements
 * @property {PollState} polls
 * @property {ViewState} view
 * @property {SchemasState} schemas
 * @property {EventsState} events
 */

export default combineReducers({
  app,
  view: viewReducer,

  device: deviceSlice.reducer,
  user,

  video: videoReducer,
  extensions: extensionsReducer,

  // mns: mnsReducer,

  emoji: emoji.emojiReducers,
  assets: assetsSlice.reducer,

  interpolation: interpolationReducer,
});
